export default {
    ok: "D'accord",
    no: "Non",
    download: "Télécharger",
    continue: "Continuer",
    resume: "Reprendre",
    changeLang: "Changer la langue",
    players: "joueurs",
    add: "Ajouter",
    lesgo: "C'est parti !",
    objectiveUpdated: "Objectif mis à jour",
    //objectives: "Objectives",
    objectives: "Objectifs",
    objective: "Objectif",
    //objective: "Objective",
    sounds: "Sons",
    volume: "Volume",
    music: "Musique",
    quitStory: "Quitter l'histoire",
    enterPlayerName: "Entrez le nom d'un joueur ou le #Code joueur d'un ami",
    deleteStory: "Supprimer l'histoire",
    choose: "Choisir",
    newState: "Nouvel état",
    storyVersion: "Version de l'histoire",
    downloading: "Téléchargement...",
    language: "Langue",
    options: "Paramètres",
    about: "À propos",
    legalMentions: "Mentions légales",
    confidentiality: "Confidentialité",
    ourSocials: "Nos réseaux",
    rateUs: "Nous évaluer",
    credits: "Crédits",
    discordSub: "Rejoignez une commu de folie",
    instagramSub: "Suivez nos superbes posts",
    twitterSub: "Suivez notre incroyable actu",
    fbSub: "Likez-nous sans modération",
    ytSub: "Suivez nos vlogs improbables",
    team: "L'équipe",
    thankss: "Remerciements",
    collab: "Avec la participation de",
    news: "Actualités",
    newsSubtitle: "Retrouve toutes nos dernières actualités",
    stories: "Histoires",
    decisive: "Choix décisifs",
    change: "Changement",
    secret: "Séquence secrète ",
    secretTextHide: "Cette séquence ne te concerne pas",
    legalUrl: "https://talesup.io/legal/fr",
    cguvUrl: "https://talesup.io/cguv/fr",
    confiUrl: "https://talesup.io/politique/fr",
    discoverStories: "Découvrez les histoires",
    welcome: "Bienvenue !",
    welcomeToTalesUp: "Bienvenue sur Tales Up !",
    welcomePartOne:
        "Voici Tales Up, une p’tite app faite avec amour dans laquelle vous trouverez des aventures pour jouer à plusieurs.",
    welcomePartTwo: "On espère que vous passerez un bon moment !",
    welcomePartThree: "- L'équipe",
    thankYouText:
        "Suis-nous pour découvrir les prochaines aventures disponibles !\n\nNous serions aussi ravis de lire tes retours sur l'app ! 🔥",
    thankYouTitle: "Merci d'avoir joué à cette histoire !",
    laterPromise: "Plus tard promis",
    signIn: "Connexion",
    signUp: "Inscription",
    forgotPassword: "Mot de passe oublié",
    register: "Inscription",
    closedBeta: "Beta fermée",
    closedBetaSub: "Bienvenue sur la beta fermée de Tales Up.",
    closedBetaSub2:
        "Toute ta progression sur cette version est temporaire et ne sera ni conservée ni répercutée sur la version officielle, que ce soit sur l'application mobile déjà existante ou sur la future  version publique sur navigateur.",
    closedBetaSub3:
        "Entre le code d'accès à la beta que tu as reçu pour continuer.",
    registerWithEmail: "S'inscrire via email",
    newsletterRegister:
        "Je souhaite recevoir les emails de Tales Up, pas de spam promis 🙃",
    required: "requis",
    resetPassword: "Réinitialisation du mot de passe",
    resetPasswordIntro1: "Dommage 😞, il n'y a rien qu'on puisse faire !",
    resetPasswordIntro2:
        "Non, c'est une blague, entre ton adresse e-mail ci-dessous et nous t'enverrons un e-mail pour réinitialiser ton mot de passe.",
    resetEmailSent:
        "Nous t'avons envoyé un e-mail pour réinitialiser ton mot de passe",
    shop: "Boutique",
    shopSubtitleStory: "Histoires & Séries",
    shopSubtitleAvatar: "Avatars & Cosmétiques",
    shopSubtitleFeatured: "À l'affiche",
    shopSubtitleFeatured2:
        "Des offres personnalisées rien que pour toi, des cadeaux toutes les semaines et les dernières actualités et sorties",
    shopSubtitleTickets:
        "Achète notre super Pass Aventurier ou des tickets pour obtenir des histoires, des offres, ou encore des cosmétiques et avatars",
    shopSubtitleTickets2:
        "Tu peux aussi te rendre sur l'application mobile si tu souhaites payer dans d'autres devises ou avec un autre moyen de paiement",
    shopSubtitleTickets3: "Les tickets sont uniquement disponibles à l'achat",
    shopSubtitleTicketsUnavailable:
        "Indisponible pour le moment 🤙 (en attendant, tu peux toujours acheter des tickets via l'application Tales Up, dispo sur iOS et Android)",
    currencies: "Monnaies",
    library: "Aventures",
    storyShop: "Achat d'histoires",
    errorNoTrad: "Non disponible dans cette langue",
    alreadyExists: "Tu as déjà acheté cette histoire",
    alreadyExistsTitle: "Déjà achetée",
    notEnougthTickets: "Oups, on dirait qu'il te manque des tickets !",
    notEnoughTokens: "Oups, on dirait qu'il te manque des jetons !",
    notEnougthTicketsTitle:
        "Oups, on dirait que tu n'as pas assez de tickets pour acheter cette histoire",
    serverUnderMaintenance: "Maintenance en cours",
    maintenancePartOne:
        "Les serveurs sont en cours de maintenance, consulte notre twitter pour plus d'informations",
    checkTwitter: "Regarder sur Twitter",
    newVersionAvailable: "Nouvelle version",
    updateVersion: "Mettre à jour Tales Up",
    updatePartOne:
        "Une nouvelle version de Tales Up est disponible dans les stores, merci de mettre à jour l'application pour continuer à jouer",
    saves: "Sauvegardes",
    cancel: "Annuler",
    deleteSaveTitle: "Attention",
    deleteSaveMsg:
        "Tu es sur le point de supprimer cette sauvegarde. Cette action est définitive et aucune récupération n'est possible. Es-tu sûr de vouloir supprimer cette sauvegarde ?",
    selectSaveToLoad:
        "Sélectionne une sauvegarde de l'épisode précédent pour continuer",
    seeAchievement: "Voir les succès",
    playerUnlockedThis: "des joueurs l'ont débloqué",
    achievementsCompleted: "succès complétés",
    achievementCompleted: "Succès complété",
    achievementsCompletedMaj: "Succès complétés",
    achievements: "Succès",
    storiesOwned: "histoires possédées",
    episode: "Épisode",
    Episodes: "Épisodes",
    episodes: "épisodes",
    getAllEpisodes: "Obtenir tous les épisodes",
    enterEpOne: "Entrer ep. 1",
    buyEpisode: "Acheter cet épisode génial ?",
    howToBuyEpisode: "Comment veux-tu acheter cet épisode ?",
    greatChoice:
        "Très bon choix ! On vient d'ajouter l'histoire à ta bibliothèque.",
    greatChoicePack:
        "Très bon choix ! On vient d'ajouter tous les articles à ta bibliothèque.",
    cantBuyPack:
        "Impossible d'acheter ce pack. Tu le possèdes déjà ou il n'est plus avantageux pour toi.",
    goCheck: "Aller voir",
    greatChoiceItem:
        "Très bon choix ! Nous avons ajouté cet objet à ta collection.",
    greatChoiceSlot:
        "Très bon choix ! On vient d'ajouter cet emplacement à ton compte",
    yeahIKnow: "Je sais !",
    switchAccount: "Changer de compte",
    createAccount:
        "Crée un compte pour découvrir nos histoires et sauvegarder ta progression",
    alreadyOnTalesUp: "Déjà sur Tales Up ? ",
    login: "Connecte-toi",
    signInSubtitle: "Connecte toi à ton compte Tales Up",
    confirmed: "Activation",
    confirmedForgot: "Confirmé !",
    buyStory: "Acheter cette histoire incroyable ?",
    howToBuyStory: "Comment veux-tu acheter cette histoire ?",
    buyAllEpisode: "Acheter cette incroyable série ?",
    sureToExit: "Es-tu sûr de vouloir quitter ?",
    looseAchievements: "Tu perdras tes succès dévérouillés durant cette partie",
    exit: "Quitter",
    back: "Annuler",
    newPseudo: "Nouveau pseudo",
    update: "Enregistrer",
    titlesUnlocked: "Titres dévérouillés",
    registerSubtitle:
        "Crée un compte Tales Up pour découvrir les histoires et sauvegarder ta progression !",
    activationEmailSent:
        "Un email d'activation t'as été envoyé à l'adresse fournie",
    registerConfirmedSubtitle:
        'Ton compte a bien été créé ! Tu peux désormais te connecter en appuyant sur le bouton "Connexion" ci-dessous.',
    registerConfirmedSubtitleBis:
        "Ton compte a bien été créé ! Tu peux désormais te connecter en  utilisant ces identifiants",
    registerConfirmedSubtitle2:
        "Nous te souhaitons de bonnes aventures sur Tales Up !",
    activationEmailSent2:
        "Merci d'activer ton compte pour te connecter à Tales Up",
    activationEmailSent3:
        "Cela peut prendre quelques minutes à arriver, pense à vérifier dans les spams et s'il n'y a rien, utilise le bouton 'je n'ai pas reçu l'email'",
    done: "C'est fait !",
    error: "Erreur",
    understood: "Compris !",
    deleteSave: "Supprimer",
    delete: "Supprimer",
    keepIt: "Conserver",
    allSaves: "Tes aventures sont sauvegardées ici",
    savesUsed: "sauvegardes utilisées",
    replace: "Remplacer",
    confirm: "Confirmer",
    selectSlot:
        "Sélectionne un emplacement vide ou une sauvegarde existante pour la remplacer",
    replaceSaveMsg:
        "Tu es sur le point de remplacer cette sauvegarde. Cette action est définitive et aucune récupération n'est possible. Es-tu sûr de vouloir remplacer cette sauvegarde ?",
    great: "Super !",
    noSaveToLoad:
        "Oups, on dirait que tu n'as pas de sauvegarde de l'episode précédent",
    logout: "Déconnexion",
    support: "Assistance",
    upgrade: "Mettre à jour",
    contactSupportDescription:
        "Si tu rencontres un problème avec l'application, qui n'est pas détaillé dans la liste ci-dessous, envoie nous une description détaillée via le bouton ci-dessous. Nous te répondrons dans les plus brefs délais !",
    contactUs: "Nous contacter",
    tickets: "Tickets",
    tokens: "Jetons",
    title: "Titre",
    titlesList: "Titres",
    rewardReceived: "Félicitations ! Tu as reçu une nouvelle récompense",
    achievementLocked: "Succès verrouillé",
    buyItem: "Tu veux acheter cet objet incroyable ?",
    item: "Objet",
    password: "Mot de passe",
    passwordLost: "Mot de passe oublié",
    rescueMe: "Sauvez-moi !",
    achievementsUnlocked: "Succès débloqués",
    noTradsAvailable:
        "de tes histoires ne sont pas disponibles dans cette langue",
    noTradAvailable: "de tes histoires n'est pas disponible dans cette langue",
    welcomeAboard: "Bienvenue dans Tales Up !",
    welcomeAboardSub:
        "Ici, tu pourras vivre des aventures épiques avec tes potes mais prends garde, chaque choix a des conséquences... (Clique pour confirmer, re-clique avant la fin pour annuler)",
    welcomeChoice1: "Trop cool ! Merci",
    welcomeChoice2: "Ah... C'est tout ?",
    welcomeAboard2: "Méfie toi des conséquences...",
    welcomeAboard2Sub1:
        "Ah, un peu lèche-botte sur les bords alors... J'aime bien ! Pour la peine je t'ai offert les premiers épisodes de chaque série et saga. C'est bien parce que c'est toi !",
    welcomeAboard2Sub2:
        "Ah, un peu cancre sur les bords alors... J'aime bien ! Pour la peine je t'ai offert les premiers épisodes de chaque série et saga. C'est bien parce que c'est toi !",
    welcomeAboard3: "Qualité et honnêteté",
    welcomeAboard3Sub:
        "Eh oui, ici pas de pubs ou autre modèle douteux. Si tu veux profiter des aventures complètes, il te faudra les acheter ou obtenir notre super pass. Cependant, si tu possèdes une aventure, tes amis pourront y jouer gratuitement avec toi !",
    welcomeAboard4: "Un seul endroit pour tes histoires !",
    welcomeAboard4Sub: "Choisis en une et pars à l’aventure !",
    iGetItMaster: "Je ferai attention maître ✌️",
    letMePlayNow: "Non mais tu me prends pour qui ? ☠️️",
    titleReceived: "Tu as reçu un nouveau titre !",
    discoverLibrary: "Découvrir les aventures et le bonheur avec 🔥",
    notNow: "Plus tard",
    hellYes: "Ouiii !",
    getTickets: "En acheter",
    seeMyItems: "Se changer",
    avatar: "Avatar",
    emailRequired: "L'email est obligatoire",
    emailInvalid: "L'email est invalide",
    passwordRequired: "Le mot de passe est obligatoire",
    passwordInvalid: "Le mot de passe est invalide",
    pseudoRequired: "Le pseudo est obligatoire",
    pseudoInvalid: "Le pseudo est invalide",
    passwordStrength:
        "Ton mot de passe doit comprendre au moins 8 caractères, une majuscule, un chiffre et un caractère spécial.",
    changePseudo: "Changer de Pseudo",
    changeTitle: "Changer de Titre",
    goToShop: "Par ici !",
    slotAvailable: "Emplacement disponible",
    joinGame: "Rejoindre une partie",
    jumpFriend: "Plongez dans l'aventure d'un ami",
    writing: "Écriture",
    art: "Art",
    sound: "Sons",
    playerDidThis: "des joueurs l'ont fait",
    popupSave:
        "Il semblerait que tu ais déjà utilisé tous tes emplacements de sauvegardes. Si tu souhaites sauvegarder, choisis une sauvegarde à remplacer.",
    popupSaveDone:
        "Une sauvegarde de l'épisode a été créé autimatiquement. Veux-tu continuer ta partie ?",
    dontSave: "Passer",
    createSave: "Créer une sauvegarde",
    saveSuccessful: "La sauvegarde a bien été créée !",
    agreeTerms: "J'accepte les ",
    agreeTerm: "J'accepte la ",
    terms: "conditions générales",
    privacyPolicy: "Politique de confidentialité",
    Terms: "Conditions générales",
    introTerms:
        "En utilisant cette application, vous indiquez que vous avez lu et compris les conditions d’utilisation et que vous acceptez de les respecter en tout temps.",
    join: "Rejoindre",
    codeRequired: "Le code est obligatoire",
    code6Characters: "Le code doit faire 6 caractères",
    progress: "Progression",
    social: "Émissaire",
    success: "Succès",
    missionDone: "Complétées",
    noNewItemAvailable:
        "Plus aucun objet de cette catégorie n'est actuellement en vente !",
    noNewTicketsAvailable:
        "On dirait que les tickets ne sont pas disponibles à la vente dans ton pays ou sur ton téléphone. 🙃",
    noNewStoryAvailable:
        "On dirait que tu as déjà toutes les histoires ! Merci beaucoup ☺️ Ne t'en fais pas, on essaye d'en publier régulièrement 🙃",
    featured: "À l'affiche",
    incomingStory: "Histoire à venir",
    enter: "Saisir",
    promo: "Promo",
    enjoyYourNewTickets:
        "Merci beaucoup ! Profite bien de tes nouveaux tickets !",
    enjoyYourNewTicketsAds: "Profite bien de tes nouveaux tickets !",
    goShopping: "Faire du shopping",
    logoutMsg: "Es-tu sûr de vouloir te déconnecter ?",
    logMeOut: "Oui !",
    logedInAs: "Connecté avec",
    activateSound:
        "Pour une meilleure expérience de groupe, lisez à haute voix et augmentez le volume !",
    activateSoundIOS:
        "Pour une meilleure expérience de groupe, lisez à haute voix, désactivez le mode silencieux et augmentez le volume !",
    okay: "Okay",
    onlineRoom: "En ligne",
    availableSoon: "(indisponible)",
    onlineRoomSub: "Joue avec tes amis du monde entier",
    boardGameRoom: "Local / Solo",
    soloRoom: "Mode solo",
    playerCode: "#codejoueur",
    boardRoom: {
        title: "Local / Solo",
        subtitle:
            ", joue avec tes amis ou des compagnons autour du même appareil",
        enterName: "Entre le nom de tous les joueurs",
        enterCode: "Entre leur ",
        underPseudo: '(Affiché sous le pseudo dans "Mes histoires")',
        tip: "Astuce : Ajouter un joueur via son",
        tipEnd: " lui permet de débloquer également les succès de l'histoire !",
    },
    code: "code",
    onlineRoomModal: {
        title: "Mode en ligne",
        subtitle: ", chacun joue sur son téléphone et vote pour ses choix.",
        sendThe: "Envoie le",
        ofGame: "de la partie à tes amis",
        button: "1. Un bouton “Rejoindre une partie” se trouve dans l’onglet “Mes histoires” de l’app !",
        ownStory:
            "2. Vos amis n’ont pas besoin de posséder l’histoire pour rejoindre votre partie !",
        tip: "Pas d’amis disponibles ? Viens en trouver sur notre ",
        discord: "Discord",
        tipEnd: " ! 😉",
    },
    boardGameRoomSub:
        "Joue avec tes amis ou des compagnons autour de cet appareil",
    soloRoomSub: "Idéal pour explorer les histoires à ta guise",
    copied: "Copié",
    missionRewardPopup: "Complète des missions pour débloquer cet objet !",
    playerNotFound:
        "Nous n'avons pas trouvé ce joueur, es-tu sûr d'avoir bien entré son code ? Pour rappel, le code est affiché sur la page Mes Histoires sous le titre et est précédé d'un #",
    playerAlreadyExists: "Ce joueur est déjà dans la liste !",
    stillNotReceived: "Je n'ai toujours pas reçu l'email",
    missionText: "Complète les missions de l'histoire pour débloquer cet objet",
    errorGoogle:
        "Une erreur s'est produite, merci de réessayer. Si cette erreur persiste, contacte-nous à l'adresse contact@talesup.io.",
    errorGooglePwd:
        "Ce compte a été créé avec Google, connecte-toi avec le bouton 'Continuer avec Google'",
    errorFbPwd:
        "Ce compte a été créé avec Facebook, connecte-toi avec le bouton 'Continuer avec Facebook'",
    errorApplePwd:
        "Ce compte a été créé avec Apple, connecte-toi avec le bouton 'Continuer avec Apple'",
    continueWithGoogle: "Continuer avec Google",
    continueWithFacebook: "Continuer avec Facebook",
    continueWithApple: "Continuer avec Apple",
    or: " OU ",
    orContinueWith: " Ou continuer avec ",
    pleaseDontLeave:
        "Merci beaucoup ! On est en train de valider ton achat ! Ne quitte pas l'application, ça ne sera pas long 🔥",
    verifyingOrder: "Validation en cours",
    purchaseCanceledOrRefusedPayment:
        "Tu as annulé ton achat ou ton paiement a été refusé",
    anErrorOccured: "Une erreur s'est produite",
    purchasePending: "Paiement en attente",
    purchasePendingSub:
        "Merci, ton paiement est en attente, lorsque nous aurons la confirmation, tu recevras tes tickets. Si ton paiement est refusé il ne se passera rien. Tu peux fermer cette popup, une autre s'ouvrira lorsqu'on aura reçu la confirmation.",
    level: "Niveau",
    congrats: "Félicitations ! 🥳",
    levelUp: "Tu passes au niveau ",
    information: "Information",
    seriesDecoupage:
        "Cette histoire était présente sur la démo. Cette histoire a été découpée en plusieurs épisodes. Les épisodes ne sont donc pas une suite de l'histoire présente sur la démo.",
    show: "Afficher",
    readMore: "Lire plus",
    readLess: "Lire moins",
    notUnlocked: "Non débloqué",
    notUnlockedSub: "???",
    showMe: "Montrez moi",
    missingEpisodes:
        "Il te manque des épisodes pour pouvoir compléter cette mission. Tu pourras recevoir les récompenses quand tu les possèderas tous ! 🔥",
    cookies: "Cookies",
    manageChoices: "Gérer mes choix",
    goBack: "Retour",
    goBackToLibrary: "Retourner à la bibliothèque ?",
    confirmGoBack:
        "Es-tu sûr de vouloir quitter ? Tu perdras tes succès dévérouillés durant cette partie",
    acceptTerms:
        "Accepte les conditions d'utilisation et la politique de confidentialité pour finaliser ton inscription",
    acceptTermsMandatory: "Vous devez accepter les conditions générales",
    acceptRgpdMandatory: "Vous devez accepter la politique de confidentialité",
    promoCode: "Entrer un code",
    addedToLibrary: "Nous avons ajouté ces récompenses à ton compte",
    articles: "Articles",
    contact: {
        issue: " : Problème Tales Up",
        infos: "Infos utilisateur : (ne pas supprimer) %0Aid : ",
        problem:
            "%0A%0AVotre problème (merci d'ajouter toutes les infos que vous jugez utiles) :%0A",
    },
    playersConcerned: "Personnes concernées",
    playerConcerned: "Personne concernée",
    backToGroup: "Retour au groupe",
    nowReady: "Est maintenant prête à être jouée",
    promoErrors: {
        promoAlreadyUsed: "Tu as déjà utilisé ce code",
        promoSoldOut:
            "Le nombre maximum d'utilisations de ce code a déjà été atteint",
        promoNotExist: "Ce code n'existe pas",
        promoNotActive: "Ce code n'est plus disponible",
        promoNotValid: "Ce code est invalide",
    },
    deleteAccount: "Supprimer mon compte",
    deleteAccountInfo:
        "En appuyant sur confirmer, la procédure de suppression de compte commencera et ne pourra pas être annulée. Cette action est définitive, aucun retour en arrière ne sera possible. Veux-tu vraiment supprimer ton compte ?",
    deleteAccountConfirm:
        "Nous sommes tristes de te voir partir 😔 Confirmes-tu la suppression de ton compte ? Tu recevras un email une fois la procédure terminée.",
    deleteAccountError:
        'Une erreur s\'est produite durant la suppression de ton compte, merci de nous contacter via le bouton "Nous contacter" dans le menu "Assistance" sur la page précédente',
    end: "Fin !",
    youCan: "tu pourras",
    in: "Dans",
    playYourStories: "Jouer à tes histoires et séries",
    consultProgress:
        "Consulter ta progression, tes missions et récupérer tes récompenses",
    customizeAvatar: "Personnaliser ton avatar et changer ton titre",
    next: "Suivant",
    weve: "Nous t'avons",
    offered: "offert",
    theseStories: "ces histoires",
    weveOfferedYouStories: "On t'a offert des histoires !",
    complete: "Histoire entière",
    asWellAs: "Ainsi que",
    firstEp: "1er épisode",
    of: "de",
    packs: "Packs",
    seeMore: "Voir plus",
    owned: "Possédé",
    buyPack: "Tu veux acheter ce pack ?",
    resetLang:
        "La langue a été changée, appuies sur Okay pour relancer l'appli afin que le changement soit pris en compte",
    mypseudo: "monpseudo",
    pseudo: "Pseudo",
    mypassword: "mot de passe",
    notAvailable: "Indisponible",
    remark: "remarque",
    alreadyClaimed:
        "Tu as déjà récupéré la récompense pour cette mission (cela peut prendre quelques instants à s'afficher)",
    emailResent: "Nous t'avons renvoyé un email d'activation",
    sent: "Envoyé",
    value: "valeur",
    ftueFeatured: {
        discover:
            "Découvrir nos dernières sorties (histoires, séries, avatars...)",
        promo: "Profiter de nos promotions hebdomadaires",
        news: "Suivre nos différentes actualités (équipe, projet...)",
    },
    ftueShop: {
        story: "Débloquer de nouvelles histoires et séries",
        item: "Débloquer de nouveaux objets et avatars ",
        ticket: "Acheter des tickets",
        packs: "Unlock bundles",
    },
    ftueQuest: {
        level: "Suivre l’avancée de tes quêtes et monter de niveau",
        item: "Débloquer des objets et avatars uniques",
        ticket: "Récupérer des jetons",
        title: "Obtenir des titres exclusifs aux histoires et séries",
    },
    new: "Nouveau",
    le: "le",
    la: "la",
    les: "les",
    secretSequence: {
        choiceToTell: "Garde les informations qui vont suivre pour toi",
    },
    ftueSolo: {
        sub: "tu prends les décisions pour toi et les membres de ton équipe",
        soloWarning:
            "Certaines fonctionnalités sont moins adaptées au mode solo",
        loline: "Loline",
        lolineSub:
            "est une aventurière sauvage et farouche. Elle n'a peur de rien ni de personne",
        alphonse: "Alphonse",
        alphonseSub:
            "peut sembler rude et froid au premier abord. Mais il n'y a pas plus fidèle que lui",
        eugenie: "Eugénie",
        eugenieSub:
            "cache bien son jeu. Sous ses airs timides se cache une tacticienne hors pair",
    },
    endGame: {
        title: "Et maintenant ?",
        recommand: "Recommandations",
        stories: "Tes histoires",
        back: "Retour au menu",
    },
    levels: {
        title: "Niveaux",
        sub: "Monte de niveau en terminant des quêtes et récupère des récompenses",
        gotReward: "Tu peux récupérer de nouvelles récompenses de niveau !",
        disciple: "Disciple",
        prodigy: "Prodige",
        master: "Maître",
        legend: "Légende",
    },
    quests: {
        quests: "Quêtes",
        weekly: "Hebdomadaires",
        questsCompleted: "Missions completées",
        questsSubtitle:
            "Complète des quêtes pour gagner des récompenses et monter de niveau !",
    },
    ads: {
        watch: "Regarde une vidéo pour gagner des jetons",
        congrats: "Merci beaucoup ! Profite bien de tes nouveaux jetons !",
    },
    consent: {
        needConsentTitle: "Nous avons besoin de ton consentement",

        needConsentSub:
            'Les publicités sont facultatives mais si tu souhaites en voir, nous avons besoin de ton consentement.\n\nMerci de changer tes préférences en cliquant sur le bouton "Changer mes préférences" ci-dessous puis "Autoriser"',
        needConsentSubIOSUnder14:
            'Les publicités sont facultatives mais si tu souhaites en voir, nous avons besoin de ton consentement.\n\nMerci de changer tes préférences en cliquant sur le bouton "Changer mes préférences" ci-dessous puis aller dans Réglages > Confidentialité > Publicité > Désactiver le "suivi publicitaire limité"',
        noAdsToShowTitle: "Nous ne parvenons pas à charger de vidéo 😢",
        noAdsToShowAndroid:
            'Il est possible que tes préférences en matière de suivi bloquent certaines publicités ou restreignent leur nombre, nous t\'invitons à vérifier tes préférences en cliquant sur le bouton "Changer mes préférences" ci-dessous puis "Autoriser".\n\nSi tu as déjà autorisé, merci de réessayer un peu plus tard.',
        noAdsToShowIOSOk:
            "Il semblerait que nous n'ayons pas de vidéo à te montrer pour l'instant.\n\nMerci de réessayer un peu plus tard.",
        noAdsToShowIOSNotOk:
            'Il est possible que tes préférences en matière de suivi bloquent certaines publicités ou restreignent leur nombre, nous t\'invitons à vérifier tes préférences en cliquant sur le bouton "Changer mes préférences" ci-dessous puis "Autoriser le suivi".\n\nSi tu as déjà accepté, merci de réessayer un peu plus tard.',
        noAdsToShowIOSNotOkUnder14:
            'Il est possible que tes préférences en matière de suivi bloquent certaines publicités ou restreignent leur nombre, nous t\'invitons à réessayer plus tard ou à vérifier tes préférences en cliquant sur le bouton "Changer mes préférences" ci-dessous puis en allant dans Réglages > Confidentialité > Publicité > Désactiver le "suivi publicitaire limité"',
        manageOptions: "Changer mes préférences",
        preferencesUpdated: "Préférences mises à jour",
    },
    purchase: {
        title: "Paiement",
        validate: "Paiement validé",
        validateSub:
            "Merci beaucoup ! Ton achat a bien été effectué, tu devrais recevoir tes tickets ou ton pass d'ici quelques secondes ainsi qu'un reçu par email. Profites-en bien !",
        validationError: "Erreur de validation",
        paymentError: "Erreur de paiement",
        paymentErrorSub: "La transaction a échoué, une erreur est survenue :",
        backToStore: "Revenir à la boutique",
    },
    // Purchase errors
    purchaseErrors: {
        receiptErrorIOS:
            "Il semblerait qu'Apple ai rejeté le reçu de transaction, cela peut arriver si ton IPhone est \"jailbreaké\" ou si les serveurs d'Apple ou les nôtres sont temporairement fermés. La transaction n'ayant pas aboutie, nous réessaieront de la finaliser. Si le  problème persiste, n'hésites pas à nous contacter via le bouton \"Assistance\" dans le Menu.",
        receiptErrorAndroid:
            'Il semblerait que Google ai rejeté le reçu de transaction, cela peut arriver si ton téléphone est "jailbreaké" ou si les serveurs de Google ou les nôtres sont temporairement fermés. La transaction n\'ayant pas aboutie, nous réessaieront de la finaliser. Si le  problème persiste, n\'hésites pas à nous contacter via le bouton "Assistance" dans le Menu.',
        purchaseGlobalError:
            "Une erreur a eu lieu durant la transaction. La transaction n'ayant pas aboutie, nous réessaieront de la finaliser. Si le  problème persiste, n'hésites pas à nous contacter via le bouton \"Assistance\" dans le Menu.",
        errorCode: "Code erreur : ",
        err01: "Nous n'avons pas réussi à compléter la transaction. Code: ERR-01",
        err02: "Nous n'avons pas réussi à compléter la transaction. Code: ERR-02",
        err03: "Nous n'avons pas réussi à compléter la transaction. Impossible de valider un achat ayant déjà échoué. Code: ERR-03",
        err04: "Nous n'avons pas réussi à compléter la transaction. Le compte qui a effectué cet achat est différent de celui avec lequel vous êtes connecté. Code: ERR-04",
        err05: "Nous n'avons pas réussi à compléter la transaction. Il semblerait que les informations soient invalides. Code: ERR-05",
        err06: "Nous n'avons pas réussi à compléter la transaction. Il semblerait que  vous ne soyez pas connecté, essayez de rafraichir la page et de vous reconnecter ou appuyez sur \"Besoin d'aide\". Code : ERR-06",
        err07: "Nous n'avons pas réussi à compléter la transaction. essayez de rafraichir la page et de vous reconnecter ou appuyez sur \"Besoin d'aide\". Code : ERR-07 ",
        err08: "La transaction a été annulée. Code : ERR-08",
    },

    // ----
    actions: {
        cancel: "Annuler",
        gotIt: "J'ai compris",
        invitePlayers: "Inviter",
        leave: "Quitter",
        leaveGame: "Quitter la partie",
        startGame: "Commencer la partie",
        sure: "Quitter ?",
        remove: "Exclure ?",
        yes: "Oui",
        resume: "Reprendre",
        skip: "Passer",
        send: "Envoyer",
        enterMessage: "Entre ton message",
        roll: "Lancer",
        addPlayer: "Ajouter Joueur",
        accept: "Accepter",
        decline: "Refuser",
        collect: "Récupérer",
    },
    errors: {
        invalidCode: "Ce code est invalide",
        gameAlreadyStarted: "Il semblerait que cette partie ait déjà commencé",
        hasReachedPlayerMaxLimit:
            "Il semblerait que le nombre maximum de joueurs ait été atteint pour cette partie",
        noGameExists: "Il semblerait que cette partie n'existe pas",
        playerNotInSave:
            "Vous n'êtes pas dans la liste des joueurs de l'épisode précédent",
        notSameLanguage:
            "Cette partie n'est pas dans votre langue, merci de changer pour pouvoir la rejoindre",
        errorOccured:
            "Une erreur est survenue, merci de relancer l'application et de réessayer",
        notEnoughTickets: "Oups, on dirait que tu n'as pas assez de tickets !",
        notEnoughSlots:
            "Oups, on dirait que tu n'as pas assez d'emplacements disponibles",
        cantAddYourself: "Tu ne peux pas t'ajouter toi même à tes ami(e)s",
        notLoggedIn:
            "Il semblerait que tu ne sois pas connecté, merci d'actualiser la page",
    },
    labels: {
        gameID: "Code",
        gameStopped: "La partie a été arrêtée",
        player: "Joueur",
        players: "Joueurs",
        remember: "Rappelez-vous",
        waitingFor: "En attente de",
        waiting: "En attente..",
        you: "Toi",
        info: "Information",
        enterAnswer: "Entrez votre réponse:",
        gameOver: "Game Over",
        resume: "Reprendre la partie ?",
        rewards: "Récompenses",
        needHelp: "Besoin d'aide ?",
        availableNow: "Disponible Maintenant",
        experience: "Expérience",
        rollDice: "Lancer de dés",
        youGotA: "Tu as fait",
        getMoreThan: "Obtiens plus de",
        toSucceed: "pour réussir cette action",
        random: "Aléatoire",
        success: "Succès",
        failure: "Echec",
        addPlayerSubtitle: "Ajouter quelqu'un jouant autour de cet appareil",
        yourPlayerCode: "Ton code joueur: ",
        guest: "Invité",
        soloOnly: "Cette histoire n'est jouable qu'en solo",
    },
    messages: {
        alreadyVoted: "Tu as déjà voté",
        enterGameID: "Veuillez entrer un code de partie",
        hasLeftOnlineGameMessage: "Vous avez quitté la partie !",
        leavingGameForHost:
            "Quitter le jeu en tant qu'hôte mettra fin au jeu pour tout le monde !",
        leavingGameForPlayer:
            "Quitter le jeu pénalisera la bon déroulement de la partie pour les autres joueurs !",
        notConcerned: "Ce n'est pas à toi de voter",
        removePlayerForGame: "Exclure cette personne ?",
        shareGameID:
            "Partage le code ci-dessus avec d'autres personnes afin qu'elles puissent rejoindre cette partie !",
        storyDownload: "Téléchargement de l'histoire...",
        waiting:
            "Certains joueurs ne sont pas encore prêts... \n\n(Cette popup s'affiche si un ou plusieurs joueurs n'ont pas encore changé de passage. Cela peut prendre plus de temps sur certains appareils ou selon leur connexion. De plus, veillez à ce que tous les joueurs restent sur la page / l'application).",
        waitingHost: "On attend l'hôte pour commencer...",
        waitingPlayers: "On attend que tout le monde soit là...",
        sound: "Pour plus d'immersion, nous vous recommandons de jouer avec le son.",
        bug: "Le changement de passage peut prendre plus de temps d'un appareil à l'autre ou selon la connexion. Veillez à ce que tous les joueurs restent sur l'application, en particulier l'hôte de la partie. Un chat est disponible en appuyant sur le bouton en haut à droite.",
        bugLoading:
            "Le chargement semble anormalement long, veux-tu essayer de te resynchroniser ?",
        anErrorOccuredOfferReward:
            "Une erreur s'est produite, l'offre n'est peut-être plus disponible ou tu l'as déjà récupérée.",
        gameOver:
            "Vous pouvez retenter votre chance. Vous allez maitenant être redirigé au menu principal",
        resumeGame: "Veux-tu reprendre la partie en ligne en cours ?",
        whereFrom: "D'où vient cette image ?",
        redirectToPayment:
            "Nous allons te rediriger vers la page de paiement, veux-tu continuer ?",
        changeCurrency:
            "(Si tu souhaites changer la devise utilisée pour les paiements, rends-toi dans la boutique)",
        appNotInstalled:
            "Il semblerait que l'application Tales Up ne soit pas installée sur ton appareil. Tu peux installer Tales Up via App Store ou Google Play Store",
        diceRolled: "Les dés du destin ont décidé pour vous",
    },
    titles: {
        lobby: "Hall d'attente",
        social: "Social",
    },
    socials: {
        discord: "https://discord.gg/3NPJ7mHdS8",
        insta: "https://www.instagram.com/tales.up/",
        twitter: "https://twitter.com/tales_up",
        facebook: "https://www.facebook.com/Tales-Up-105620054346366",
        youtube: "https://www.youtube.com/channel/UC7QoABiwjVcdRGBVZ5gADyw",
    },
    time: {
        d: "j:",
        h: "h:",
        min: "min",
        m: "m",
        s: "s",
        days: "Jours",
        hours: "Hrs",
        Min: "Min",
        sec: "Sec",
    },
    currency: {
        eur: "€ EUR",
        usd: "$ USD",
    },
    featuredGroup: {
        yourGift: "Voici ton cadeau de la semaine ! Profites-en bien ! 🎉",
        freeAvatar: "+1 Avatar",
        freeGift: "1 Cadeau offert",
    },
    series: "Série",
    seriess: "Séries",
    saga: "Saga",
    adventures: "Aventures",
    comingSoon: "Bientôt disponible",
    board: {
        hint: "Indice",
        objective: "Objectif",
        //objective: "Objective",
        secret: "Secret",
        object: "États & Objets",
        adventure: "Aventure",
        univers: "Univers",
    },
    topMenu: {
        logbook: "Journal de bord",
        //logbook: "Logbook",
        information: "Informations",
        teamObject: "Objet de groupe",
        hint: "Indice",
        newHint: "Un nouvel indice a été ajouté à votre journal de bord",
        //groupObject: "Group inventory",
        groupObject: "Inventaire de groupe",
        chat: "Discussion",
        //chat: "Chat",
    },
    urls: {
        apple: "https://apps.apple.com/fr/app/tales-up/id1533630240",
        beta: "https://beta.talesup.io",
        cguv: "https://talesup.io/cguv/fr",
        contactUs: "mailto:contact@talesup.io",
        discord: "https://discord.gg/3NPJ7mHdS8",
        google: "https://play.google.com/store/apps/details?id=com.talesupreader&hl=fr",
        legal: "https://talesup.io/legal/fr",
        play: "https://play.talesup.io",
        app: "talesup://",
        privacy: "https://talesup.io/politique/fr",
        socials: "https://linktr.ee/talesup",
    },
    pass: {
        getThe: "Obtiens le",
        adventurerPass: "Pass Aventurier",
        adventurerPassPlus: "Pass Aventurier +",
        active: "Actif",
        passActive: "Pass Actif",
        pass: "Pass",
        unlock: "Débloquer",
        whatsInside: "Qu'y a-t-il dedans ?",
        yourAdvantages: "Voici à quoi tu as droit :",
        annualPass: "Pass Annuel",
        yearPass: "Pass 1 an",
        fullAccess: "Accès complet",
        noSub: "Sans abonnement",
        lifetimePass: "Pass à vie",
        unlimitedDuration: "Durée illimitée",
        getItNow: "Obtenir Maintenant ✨",
        allStories: "Accès à vie à toutes les aventures",
        avatar: "Un avatar exclusif",
        future: "Accès à toute future histoire dès sa sortie",
        title: "Un titre exclusif pour ton personnage",
        saves: "20 emplacements de sauvegarde en plus",
        reloadPage: "Il peut être nécessaire de recharger la page",
        valid: "Valable.",
        for: "À.",
        life: "Vie.",
        from: "À partir de",
        choosePass: "Sélectionne ton pass",
        allAvatars: "Tous les avatars premiums",
        allCosmetics: "Tous les cosmétiques premiums",
        allCompanionSlots: "Tous les emplacements de compagnon",
        value4: "Valeur x4",
        value5: "Valeur x5",
        enjoyYourNewPass:
            "Merci beaucoup ! Profite bien de ton nouveau Pass Aventurier et de tous ses avantages !",
    },
    companions: {
        companion: "Compagnon",
        companions: "Compagnons",
        addCompanion: "Ajouter Compagnon",
        addCompanionSubtitle: "Un compagnon virtuel de ta liste",
        selectedCompanions: "compagnon.s selectionné.s",
        cantEquip:
            "Les personnages préfaits ne peuvent pas équiper de cosmétiques",
        buySlot: "Acheter un emplacement de compagnon ?",
        buySlot1: "Acheter un emplacement",
        whatToAdd: "Que voulez vous ajouter ?",
    },
    friends: {
        friends: "Ami(e)s",
        friend: "Ami(e)",
        subtitle:
            "Ajoute des ami(e)s pour suivre leur progression et les inviter à jouer avec toi",
        requests: "Demandes",
        invites: "Invitations envoyées",
        inviteSent: "Demande d'ami(e) envoyée",
        addFriend: "Ajouter",
        request: "Demande d'ami(e)",
        invitedYou: " t'as invité à devenir ",
        friendsMin: "ami(e)s",
        removeFriend: "Veux tu supprimer ",
        fromYourList: " de ta liste d'ami(e)s ?",
        invalidCode: "Ce code joueur est invalide ou n'existe pas",
        addFriendText: "Entre un ",
        playerCode: "#codejoueur",
        selectedFriends: "ami(e)s selectionné(e)s",
    },
    ladder: {
        ladder: "Classement",
        subtitle:
            "Complète des quêtes, gagne de l'expérience, monte de niveau et gagne ta place dans le classement !",
        yourPosition: "Ta position: ",
    },
    online: {
        online: "Parties en ligne",
        subtitle:
            "Personne pour jouer avec toi ? Tu es au bon endroit ! Rejoins des parties publiques et pars à l'aventure !",
        publicGames: "Parties publiques",
        mostRecent: "Plus récentes",
        lessRecent: "Moins récentes",
        byStory: "Par aventure",
        refresh: "Raffraîchir la liste",
        noGames: "Pas de parties disponibles pour le moment",
        invitedYou: " t'as invité à jouer",
        invites: "Invitation",
        invitationsSent: "Invitation(s) envoyée(s)",
        invitationDeclined: "Une invitation a été refusée",
        public: "Publique",
        switchingTo: "En passant en ",
        publicMode: "mode public",
        privateMode: "mode privé",
        switchPublicText: ", ton lobby sera ouvert à tous !",
        switchPrivateText: ", ton lobby ne sera plus ouvert à tous.",
        inviteRequiredPlayers: "Inviter les joueurs requis",
        fromSave: "de la sauvegarde",
        wannaJoin: "Veux tu rejoindre ",
        wannaJoin2: " dans ",
    },
    user: {
        finalizeRegister: "Finalise ton inscription",
        finalizeRegisterSubtitle:
            "Tu as pour l'instant un compte invité. Ce compte temporaire est valable 30 jours et permet juste de jouer aux aventures. Pour accéder aux différentes fonctionnalités de l'application, conserver ta progression et pouvoir te reconnecter depuis n'importe où, finalise ton inscription !",
        finalizeWithEmail: "Finaliser via email",
        errorNoGuestFound:
            "Nous n'avons pas trouvé votre compte invité, merci d'actualiser la page",
        everythingReady: "Tout est pret !",
    },
    ftue: {
        startAdventure: "Débuter l'aventure 🔥",
        alreadyHaveAccount: "J'ai déjà un compte 👍",
        doItLater: "Je la ferai plus tard",
        screen1Title: "Première fois ici ou déjà inscrit(e) ?",
        screen1Subtitle:
            "Débute l'aventure Tales Up dès maintenant ou connecte-toi pour continuer !",
        screen2Title: "Bienvenue dans Tales Up !",
        screen2Subtitle:
            "Tu auras besoin d'un compte mais pour le moment, tu peux simplement entrer un pseudo et finaliser ton inscription plus tard.",
        screen3Title: "Une dernière chose",
        screen3Subtitle:
            "Ici, tu pourras vivre des aventures épiques avec tes potes mais prends garde, chaque choix a des conséquences...",
        screen4Title: "Paré(e) pour l'aventure",
        screen4Subtitle:
            "Pour te lancer dans l'aventure Tales Up, découvrons l'application !",
        storyTitle: "La Galerie",
        registerNow: "Je préfère m'inscrire maintenant",
        game: {
            title: "Mode Local / Solo",
            intro: "Dans le ",
            intro2: ", jouez seulement sur cet appareil.",
            names: "1. Ecris le nom des personnes autour de toi ou ajoute leur ",
            names2: "#codejoueur",
            names3: " s’ils ont un compte Tales Up",
            companions:
                "2. Ajoute tes compagnons pour compléter l’équipe et prends les décisions pour eux",
            solo: "3. Si tu veux jouer en solo, n’ajoute que tes compagnons dans le groupe",
        },
        library: {
            intro: "“Laisse moi te guider un peu. D’ici, tu pourras partir à la découverte des nombreuses aventures racontées dans mes tableaux.”",
            footer: "Les premiers épisodes des séries sont disponibles gratuitement.",
            stories: "1. Joue et rejoue à tes histoires et séries",
            avatar: "2. Personnalise ton avatar et change ton titre",
            companions: "3. Gère tes compagnons",
        },
        online: {
            title: "Mode en ligne",
            intro: "Dans le ",
            intro2: ", chacun joue sur son appareil et vote pour ses choix.",
            code: "1. Envoie le code à d’autres joueurs pour qu’ils puissent rejoindre",
            friends: "2. Invite directement tes amis",
            public: "3. Active l’option “Publique” pour permettre à d’autres joueurs inconnus de rejoindre l’aventure",
        },
        shop: {
            title: "Boutique",
            intro1: "Tu peux acheter des aventures à l’unité avec nos ",
            intro2: " ou opter pour le ",
            intro3: " offrant un accès complet",
            intro4: "Si tu possèdes une aventure, tes amis pourront y jouer avec toi en local ou en ligne sans frais supplémentaire.",
            footer: "Notre modèle économique se veut juste et honnête. Tu ne trouveras aucune publicité dans Tales Up.",
        },
        social: {
            title: "Social",
            intro: "“Par ici, tu trouveras d’autres aventuriers avec lesquels te lancer à la découverte d’histoires exaltantes !”",
            publicLobby:
                "1. Rejoins des parties publiques dans le Lobby, même si tu ne possèdes pas l’histoire.",
            friends:
                "2. Ajoute des amis et invite les à rejoindre tes aventures.",
            ladder: "3. Grimpe le ladder et deviens l’un des plus grands aventuries de Tales Up.",
            news: "4. Consulte les dernières actualités de l’application.",
        },
        rewards: {
            title: "Récompenses",
            intro: "“C’est ici que tu pourras observer ta progression et récupérer les récompenses que tu gagneras tout au long de tes aventures.”",
            level: "1. Suis l’avancée de tes quêtes et monte de niveau",
            mainQuest:
                "2. Débloque les histoires de la Galerie en gagnant de l’expérience",
            avatar: "3. Obtiens de nombreux objets et avatars uniques",
            titles: "4. Récupère les titres exclusifs de chaque histoire en découvrant tous leurs succès",
            parrain:
                "5. Parraine d’autres joueurs et obtiens des récompenses uniques.",
        },
    },
    mainQuest: {
        title: "La Galerie",
        subtitle: "Monte de niveau pour débloquer les épisodes de la Galerie",
        subtitle2:
            "Les épisodes de La Galerie sont des aventures uniques autour de l'histoire du jeu",
        unlocked: "Débloqué",
        unlockAtLevel: "Débloqué au niveau",
        storyTitles: [
            "La Galerie",
            "Le Peintre",
            "La Présence",
            "La Disparition",
            "L'Éclipse",
            "L'Héritage",
        ],
    },
    referral: {
        title: "Parrainage",
        subtitle:
            'Invite des amis et reçois des récompenses ! Clique sur "Inviter" ou envoie directement ton code joueur. Il suffit à tes amis de le saisir lors de leur inscription. Une fois inscrits, vous recevrez tous les deux des récompenses ici !',
        inviteeReward: "Récompense de filleul",
        referralRewards: "Récompenses de parrainage",
        referralReward: "Récompense de parrainage",
        invitee: "Filleul",
        refer: "Parrain",
        noReferrals: "Tu n'as pas de filleul pour le moment",
        referFriend: "Inviter",
        joinMe: "Rejoins moi sur Tales Up !",
        joinMeBoby:
            "Rejoins moi sur Tales Up et débloque un cosmétique exclusif ! Voici comment faire :",
        joinMeBoby2: "1. Rends-toi sur talesup.io et débute l'aventure !",
        joinMeBoby3:
            "2. Au moment de t'inscrire, lorsqu'on te le demande, entre mon code de parainnage : ",
        referralCode: "Code de parrainage",
        dontHaveCode: "Je n'ai pas de code de parrainage",
        codeDoesntExist: "Ce code n'existe pas",
        errorAddingReferral:
            "Nous n'avons pas pu ajouter ce joueur en tant que parrain",
        addReferral: "Si tu as un code de parrainage, entre le ci-dessous !",
        friendsReferred: "Ami(e)s parrainé(e.s)",
    },

    // ###################  FAQ & COOKIES ##############################
    cookiesBanner: {
        title: "Des Cookies ? 🍪",
        audience: "Audience :",
        audienceSub:
            "Les cookies d'audience nous permettent de recueillir des informations relatives à la connexion et au comportement des joueurs à des fins statistiques.",
        firebase: "Firebase Analytics",
        decline: "Refuser",
        accept: "Accepter",
        usage: "Utilisation :",
        usageSub:
            "Les cookies d'utilisation nous permettent de conserver vos préférences comme la langue à utiliser ou encore vos parties en cours.",
        all: "Tous",
        interest: "Intérêt légitime",
        policy: "En savoir plus sur notre politique de cookies",
        subtitle:
            " Nous utilisons des cookies pour sauvegarder tes préférences comme la langue à utiliser ou encore tes parties en cours ainsi que pour réaliser des statistiques de visites.",
        subtitle2:
            'Nous conservons ton choix pendant 6 mois. Tu pourras changer tes préférences une fois connecté dans "Menu > A propos > Gérer mes choix"',
        choose: "Je choisis",
        acceptAll: "Accepter tout",
        validate: "Valider",
        interestOnly: "Intérêt légitime seulement",
    },
    purchaseHelp: {
        notReceived: "Tu n'as pas reçu tes tickets ?",
        notReceivedSub:
            "Normalement, tu reçois immédiatement les tickets achetés. Si la page affiche 'Paiement validé' et que tu n'as pas eu de popup de confirmation, tu peux essayer d'actualiser la page. Si cela ne résoud pas le problème, tu peux nous contacter en appuyant sur le bouton 'Nous contacter' en bas de cette page (en incluant une capture d'écran du reçu que tu as dû recevoir par email). Si le bouton ne fonctionne pas, envoie-nous un email à l'adresse support@talesup.io (en incluant le reçu comme indiqué précedemment et en précisant l'adresse email liée au compte Tales Up avec lequel tu as fait ton achat.",
        validation: 'La page affiche "Erreur de validation" ?',
        validationSub:
            "Si la page affiche \"Erreur de validation\", cela signifie que nous n'avons pas réussi à finaliser ton paiement. Tu peux essayer d'actualiser la page, si cela ne résoud pas le problème, tu peux nous contacter en appuyant sur le bouton 'Nous contacter' en bas de cette page (en incluant une capture d'écran du reçu que tu as dû recevoir par email). Si le bouton ne fonctionne pas, envoie-nous un email à l'adresse support@talesup.io (en incluant le reçu comme indiqué précedemment et en précisant l'adresse email liée au compte Tales Up avec lequel tu as fait ton achat.",
        payment: 'La page affiche "Erreur de paiement" ?',
        paymentSub:
            "Si la page affiche \"Erreur de paiement\", cela signifie que tu as annulé l'achat en cours ou que le paiement a été refusé et que nous n'avons pas réussi à finaliser ton paiement. La transaction ayant échoué tu ne devrais pas être débité. Si toutefois il y avait un problème, tu peux nous contacter en appuyant sur le bouton 'Nous contacter' en bas de cette page. Si le bouton ne fonctionne pas, envoie-nous un email à l'adresse support@talesup.io expliquant ton problème.",
    },
    faqList: [
        {
            title: "Compte",
            articles: [
                {
                    title: "J'ai perdu mon compte",
                    sub: "Si tu t'es inscrit avec une adresse email, tu peux lancer le processus de récupération de mot de passe depuis l'écran de connexion en cliquant sur 'j'ai déjà un compte' > 'Mot de passe oublié'. Si tu t'es inscrit avec Google ou Facebook, ou que tu n'as plus accès à ta boîte mail, envoie-nous un email avec les éléments listés ci-dessous: \n\n - Ton code joueur (si tu le connais) \n - Ton pseudo (si tu le connais) \n - Ton email de connexion (email google ou facebook si ce mode de connexion est utilisé)",
                    remark: "",
                },
                {
                    title: "Quelqu'un joue avec mon compte",
                    sub: "Si tu as besoin d'aide envoie-nous un message incluant les détails à propos de ton compte, tels que listés ci-dessous: \n\n - Ton code joueur \n - Ton pseudo \n - Ton email de connexion (email google ou facebook si ce mode de connexion est utilisé)",
                    remark: "Partager des comptes de jeu va à l'encontre de nos conditionss d'utilisation. Nous nous réservons le droit de suspendre les comptes partagés ou de refuser tout service à leur propriétaire.",
                },
                {
                    title: "Comment garantir la sécurité de mon compte",
                    sub: " - Utilise un mot de passe sûr \n\n - Ne partage jamais ton compte avec qui que ce soit et ne joue jamais sur les comptes d'autres personnes. Dans le cas contraire, il se pourrait que ton compte se retrouve banni, pour plus de détails, voir nos conditions d'utilisation. \n\n - N'essaie pas de récupérer le compte d'un ami à sa place, en effet, ceci pourrait être considéré comme une tentative de hameçonnage ('phishing'). Nous n'avons aucun moyen de faire la distinction entre un ami à qui tu as demandé de l'aide ou une personne mal intentionnée qui essaie de voler ton compte. Ton ami doit contacter lui-même l'assistance.",
                    remark: "",
                },
                {
                    title: "Connexion avec Google ou Facebook",
                    sub: "Tu peux t'inscrire puis te connecter avec ton compte Google ou Facebook à Tales Up. Nous ne pouvons toutefois pas garantir que ce mode de connexion sera toujours présent dans le futur. Si une telle situation devait arriver, tu serais bien évidemment prévenu et nous te fournirions une solution de remplacement adaptée.",
                    remark: "Nous ne stockons pas de données personnelles autre que tes données de jeu, ton adresse email, pseudo, nom et prénom.",
                },
                {
                    title: "Demander la suppression de mes données personnelles",
                    sub: 'Il est tout à fait possible de demander la suppression de toutes les informations collectées par notre jeu via ton compte. \n\nPour ce faire, tu devras fermer et supprimer le comtpe de jeu de façon permanente, y compris ta monnaie en jeu et ta progression, achetée ou non, en nous envoyant un e-mail via le bouton "Nous contacter" en bas de l\'écran.',
                    remark: "",
                },
                {
                    title: "Demander une copie de mes données personnelles",
                    sub: "Nous pouvons te fournir une copie de tes données personnelles en format électronique sur demande. \n\n Voici la marche à suivre: \n\n 1. Il est nécessaire que tu sois le propriétaire du compte dont tu demandes une copie des informations personnelles. \n 2. Envoie-nous un email à l'adresse support@talesup.io, via le bouton 'Nous contacter', en demandant une copie de tes données personnelles en précisant bien ton code joueur et ton adresse email de connexion.",
                    remark: "Il nous est impossible d'envoyer des données à une adresse e-mail qui n'est pas associée au compte de jeu correspondant.",
                },
            ],
        },
        {
            title: "Achats",
            articles: [
                {
                    title: "Je n'ai pas reçu mon achat iOS",
                    sub: "La plupart du temps, tu reçois immédiatement les éléments achetés, mais il arrive que cela prenne plus longtemps. Si cela se produit, c'est parce que l'achat est encore en cours de traitement. Pas la peine d'eesayer d'acheter le même élément une nouvelle fois, il ne devvrait pas tarder à arriver ! \n\nSi tu as attendu plus de vingt-quatre heures et que tu n'as rien reçu, merci de contacter l'assistance d'Apple. Apple se charge du traitement de tous les achats effectués dans le jeu.",
                    remark: "",
                },
                {
                    title: "Je n'ai pas reçu mon achat Android",
                    sub: "Si tu as tenté de faire un achat mais que ta commande a été annulée, cette commande ne te sera pas facturée. \n\nToutefois, il est possible que Google Play Store ait appliqué une 'réserveé temporaaire à ta carte de crédit, d'un montant égal à ton achat. Mais ne t'en fais pas: ces 'réserves' s'annulent automatiquement après un bref délai. \n\nEn général, les achats sont annulés si l'adresse de facturation et/ou le nom indiqués dans Google Wallet diffèrent de ceux correspondant à votre carte bancaire. \n\nPour y remédier, contacte ta banque pour vérifier ces informations, puis connecte-toi à Google Play et consulte la section des méthodes de paiement pour t'assurer que tout est correct.",
                    remark: "Si tu as attendu plus de vingt-quatre heures et n'as rien reçu, merci de nous envoyer une capture d'écran de ton reçu à l'adresse support@talesup.io \n\nL'identifiant de transaction (par exemple: GPA.1234-1234-1234-12345) se trouvant au bas du document doit être visible sur la capture d'écran.",
                },
            ],
        },
        {
            title: "Gameplay",
            articles: [
                {
                    title: "Comment jouer ?",
                    sub: "Tu as envie de te lancer dans une histoire Tales up et tu ne sais pas par où commencer ? Tu es au bon endroit. \n\nDans un premier temps, il faut choisir une histoire et la télécharger. Ensuite, il faut choisir un mode de jeu (voir la section juste en dessous pour les modes de jeu).\n\n - Si tu choisis le mode 'plateau', il suffit ensuite de rentrer les noms de tes amis puis d'appuyer sur 'C'est parti'.\n\n - Si tu choisis le mode 'en ligne', il faut que tout le monde télécharge l'application Tales Up, et crée un compte. Une fois que tout le monde a un compte, tu peux créer une partie. Un code de partie te sera communiqué, tu n'auras plus qu'à le donner aux autres. Ils devront appuyer sur 'rejoindre une partie' depuis leur bibliothèque et entrer ce code. Dès que tout le monde aura rejoint la partie et téléchargé l'histoire, tu pourras lancer la partie.",
                    remark: "Dans le mode 'en ligne', seul le joueur hôte (celui qui crée la partie) a besoin de posséder l'histoire pour pouvoir y jouer. Tu pourras donc partager toutes les histoires que tu as acheté avec tes amis.",
                },
                {
                    title: "Les modes de jeu",
                    sub: "Comme expliqué plus haut, Tales Up propose deux modes de jeu : \n\n - Le mode 'plateau' : Comme dans un jeu de société, le téléphone fait office de plateau de jeu. Ici, le téléphone tournera entre les différentes personnes, il pourront lire à voix haute les différents textes, montrer les images, et vous vous concerterez (ou pas) pour faire les choix.\n\n - Le mode 'en ligne' : ici tout le monde a les passages sur son téléphone, et vous devrez voter individuellement (et anonymement) pour les choix. Dans certaines situations, seul un joueur peut être concerné et il n'y aura que lui qui votera.",
                    remark: "En cas d'égalité dans le mode en ligne, le choix sera tiré aléatoirement parmis les réponses à égalité.",
                },
                {
                    title: "Les choix classiques",
                    sub: "C'est la situation de base : vous êtes confrontés à plusieurs choix et vous devez vous concerter (ou voter dans le mode en ligne) pour décider lequel faire",
                    remark: "",
                },
                {
                    title: "Les choix joueur",
                    sub: "Ici, il faudra choisir une personne pour effectuer une action ou récupérer un objet. Attention, en fonction de l'état de cette personne et les actions précédemment effectuées, les choix et situations pourront différer. De plus, cela peut aussi avoir des conséquences sur la suite de l'histoire. Choisissez avec raison !",
                    remark: "",
                },
                {
                    title: "Les codes à entrer",
                    sub: "Dans certaines situations, il vous sera demandé d'entrer un code ou un mot de passe. Vous devrez cliquer sur le bouton 'saisir' puis entrer la réponse que vous pensez être la bonne et enfin, valider avec la touche de validation du clavier, qui peut différer selon les téléphones.",
                    remark: "Dans certains cas, il peut y avoir plusieurs bonnes réponses, si la votre en fait partie alors tout ira bien :)",
                },
                {
                    title: "Les changements de joueurs",
                    sub: "Vous serez souvent confrontés à des passages 'La main passe à ...', ici, vous devrez passer le téléphone à la personne dans le mode 'plateau'. Dans le mode 'en ligne', seule cette personne pourra voter jusqu'à la fin de la séquence.",
                    remark: "",
                },
                {
                    title: "Les séquences secrètes",
                    sub: "Vous rencontrerez dans certaines histoires des séquences secrètes. Ces séquences ne concernent que la personne mentionnée. Elle doit garder pour elle les informations qui lui seront transmises. Bien sûr, libre à vous de respecter ou non cette règle :)  ",
                    remark: "Dans le mode 'en ligne', les séquences secrètes ne seront affichées qu'à la personne concernée.",
                },
            ],
        },
        {
            title: "Dépannage",
            articles: [
                {
                    title: "Pourquoi ai-je constamment des alertes de perte de connexion",
                    sub: "Pour une expérience de jeu fluide, il te faut te connecter à un réseau fiable et que le signal de ton appareil soit fort. Les barres Wifi complètes ou la couverture des données mobiles (cellulaires) seules ne sont pas suffisantes pour garantir une connexion stable, car les réseaux locaux peuvent ralentir et être parfois surchargés. C'est particulièrement vrai si tu joues dans un véhicule en mouvement ou dans les transports publics souterrains. \n\nComme avec tout autre service en ligne, nous te recommandons de jouer en Wifi avec un bon fournissuer de service Internet ou au moins avec une connexion 3G/4G solide.",
                    remark: "",
                },
                {
                    title: "Problèmes techniques",
                    sub: "Si le jeu plante, le réinstaller peut parfois suffire à résoudre le problème. Cependant réinstaller le jeu doit être utilisé en dernier recours et seulement si le jeu plante de manière répétée. Si le jeu plante pendant une histoire, cela peut provenir d'un bug technique de notre côté. Dans tous les cas, si le problème persiste, envoie-nous un e-mail avec les détails du problème (si le plantage survient dans une histoire, indiquer l'histoire, l'épisode si c'est un épisode, et une partie du texte ou de contexte pour nous permettre d'identifier le problème rapidemment), via le bouton de contact, nous avons à coeur de vous proposer la meilleure expérience possible",
                    remark: "",
                },
                {
                    title: "Configuration recommandée",
                    sub: "Sur Android : OS 5 ou supérieur, 0.5 GO de RAM minimum (1 GO ou plus recommande), résolution d'écran minimum de 800x400. Sur iOS, iOS 10 ou supérieur, iPhone 5 ou appareil plus récent, 1 GB de mémoire RAM, une résolution de 640x960 minimum (résolution plus haute recommandée). \n\nCes spécifications seules ne suffisent parfois pas pour profiter pleinement du jeu. Certains modèles de téléphobes peuvent être plus appropriés pour ce jeu que d'autres.",
                    remark: "",
                },
                {
                    title: "Commentaires",
                    sub: "Nous apprécions tous les commentaires et toutes les suggestions à propos de Tales Up. Pour poster tes idées sur la façon dont nous pouvons encore améliorer l'expérience, il n'y a pas meilleur endroit que nos pages officielles sur les réseaux sociaux. \n\n Si tu souhaites rejoindre l'équipe des béta testeurs, n'hésite pas à rejoindre notre serveur Discord (lien dans 'Nos réseaux'), toute la procédure y est expliquée.",
                    remark: "",
                },
                {
                    title: " ",
                    sub: " ",
                    remark: "",
                },
            ],
        },
    ],

    cookie: {
        gestion: "Utilisation des cookies",
        accept: "J'accepte",
        acceptAll: "Tout accepter",
        customize: "Personnaliser",
        explanation:
            "Certaines fonctionnalités de notre application utilisent des services externes qui sont susceptibles d'appliquer des traceurs. Ces services sont très importants pour nous car ils nous permettent d'améliorer l'application et d'avoir connaissance de potentiels problème. Par ailleurs, tu peux à tout moment modifier tes choix dans l'application depuis le menu > À propos > Gérer mes choix. Si tu veux en savoir plus, consulte notre ",
        youChoose: "À toi de choisir",
        privacyPolicy: "Politique de confidentialité",
        save: "Enregistrer",
        cookieExplanation:
            "Voici les traceurs non obligatoires. Ils nous sont néanmoins d'une grande aide. Pour plus de détails sur la manière dont nous utilisons les cookies et les traceurs sur l'application, consulte notre  ",
        cookiePolicy: "Politique de cookies",
    },
    cookiesList: [
        {
            name: "Facebook",
            purpose: "Mesure d'audience et attribution",
        },
        {
            name: "Google Firebase Analytics",
            purpose: "Rapports de bugs, Mesure d'audience et attribution",
        },
    ],
    cookiesInfo: [
        {
            name: "1. Champ d'application de la Charte",
            text: "La présente Charte a pour vocation de s’appliquer aux supports suivants : L’application mobile Tales Up disponible sur l’App Store d’Apple, le Play Store de Google ainsi que le site web talesup.io(ci-après « Application ») ",
        },
        {
            name: "2. Que sont les cookies et autres traceurs ?",
            text: "Des outils internes ou de partenaires sont installés sur l’Application (ci-après « Outil de traçage ») afin d’accéder et de collecter des données sur votre appareil (ci-après « Identifiants »). Les données pouvant être collectées sont les suivantes : \n\nL’identifiant de l’appareil de l’utilisateur (device ID) ;\nLa version de l’Application installée sur l'appareil de l’utilisateur ;\nLe modèle de l'appareil de l’utilisateur ; \nLa version du système d’exploitation (OS) de l’appareil de l’utilisateur ; \nLe niveau de batterie de l’appareil de l’utilisateur ;\nLa langue configurée sur l’appareil de l’utilisateur ;\nL’identifiant publicitaire de l’appareil (IDFA/GAID) ; \nL'identifiant Push de l’appareil de l’utilisateur ; \nL’opérateur du téléphone ;\nLe pays, et le continent de l’utilisateur ;\nL’adresse IP. \n\nLes Outils de traçage seront désignés, individuellement ou ensemble, par le terme « Traceurs » ci-après.",
        },
        {
            name: "3. Pourquoi Périple Studio utilise des cookies et des Traceurs ?",
            text: "Périple Studio utilise des Traceurs sur son Application pour les finalités listées ci-après.\n\nPour ces finalités, Périple Studio est susceptible de permettre à des partenaires tiers de déposer des cookies ou accéder à des Identifiants et à des cookies sur le disque dur de votre terminal lorsque vous utilisez notre Application.\n\nVotre accord est une priorité pour Périple Studio, ainsi nous vous demandons votre consentement avant tout dépôt de cookies sauf pour ceux répondant à des besoins techniques, ceux-ci étant strictement nécessaires à la navigation sur le site. De même, votre consentement est exigé pour l’utilisation des Traceurs sur l’Application et la collecte des Identifiants par les Outils de traçage. Votre consentement n’est pas requis uniquement dans le cas où les Traceurs sont strictement nécessaires au fonctionnement ou à la sécurité de l’Application.\n\nIl n’y a pas de cookies déposés par les applications mobiles. En revanche, l’Application accède et collecte les Identifiants uniques de votre appareil afin de le reconnaître d’une visite sur l’autre. \nDes outils internes et partenaires et des Traceurs ont été installés sur l’Application afin d’accéder et de collecter les Identifiants.\n\nCes Traceurs permettent à Périple Studio de :\n-s’assurer du bon fonctionnement de l’Application\n-faire fonctionner certaines fonctionnalités\n-si vous y avez consenti,  les utiliser à des fins publicitaires ou d’analyse.\n\nBesoins techniques :\n\nLorsque vous consultez l’Application, des Traceurs dits de sécurité collectent et traitent des données de votre appareil. Ils peuvent être utilisés à des fins d’authentification ou de sécurité. Ils sont obligatoires pour permettre certaines fonctionnalités de l’Application et afin d’en assurer la sécurité.\nDes Traceurs dits fonctionnels sont également utilisés et permettent d’améliorer et d’optimiser votre expérience sur l’Application, ou sont nécessaires pour l’utilisation de certaines fonctionnalités.\n\nLes Outils de traçage de sécurité et fonctionnels sont strictement nécessaires à la fourniture des services Tales Up sur l’Application, ainsi vous ne pouvez pas refuser la collecte des Identifiants et l’utilisation des Traceurs de sécurité ou fonctionnels.\n\nCertains Traceurs sont spécifiques à l’Application, le cas échéant cela est indiqué dans leur finalité ci-dessous. \n\n-Facebook Login: Facebook, Fonctionnel, permettre l'inscription via Facebook\n-Google Firebase, Google, Fonctionnel, Envoyer des notifications push aux utilisateurs\n-Sign in with Google: Google, Fonctionnel,Permettre l’inscription via Google Sign-in\n\nBesoins analytiques:\n\nPériple Studio utilise des Traceurs de mesure d’audience pour obtenir des informations sur le parcours des utilisateurs, pour analyser le trafic sur l’Application et à des fins de mesures d’audience. Cela permet à Périple Studio d’améliorer l'Application selon les demandes et besoins des utilisateurs.\n\nCertains Traceurs sont spécifiques à l’Application ole cas échéant cela est indiqué dans leur finalité ci-dessous.\n\nVotre consentement est demandé pour la collecte des Identifiants et l’utilisation des Traceurs à des fins analytiques.\n\n-Facebook: Facebook, Mesure, mesure d'audience et attribution\n-Google Firebase Analytics : Google, Mesure, Mesure d'audience et attribution",
        },
        {
            name: "4. Comment gérer vos cookies et l'utilisation de vos Identifiants ?",
            text: "Lors de l’inscription sur l’Application, un écran de consentement aux traceurs vous propose d’accepter, de refuser ou de paramétrer l’utilisation des Traceurs qui ne sont pas essentiels au fonctionnement stable de l’Application.\nEn cas de nouvelle connexion sur l’Application après une déconnexion, l’écran sera affiché de nouveau et vous proposera d’accepter, de refuser ou de paramétrer l’utilisation de Traceurs.\n\nLe consentement que vous fournissez pour l’utilisation de Traceurs analytiques et publicitaires peut être retiré à tout moment.\nDepuis l’Application, Il vous suffit de cliquer sur le lien « Menu > À propos > Gérer mes choix ».\n\nÀ l’exception des Traceurs utilisés à des fins de mesures d’audience et publicitaires, tous les Traceurs de l’Application listés précédemment sont indispensables au fonctionnement stable et à l’exploitation des Services de l’Application auxquels vous avez souscrit.\n\nPour les Traceurs à des fins publicitaires, vous pouvez également configurer votre appareil afin de refuser la publicité personnalisée :\n\nPour Apple/ iOS :\n-Aller dans Réglages >  Confidentialité > Publicité\n-Activer « Suivi publicitaire limité »\n\nPour Android / Google Play Store :\n-Aller dans Paramètres > Compte ou Synchronisation ou Google (selon votre appareil) > Confidentialité ou Publicité ou Annonces (selon votre appareil)\n-Activer « Désactiver la personnalisation des annonces »",
        },
        {
            name: "5. Contact",
            text: "Si vous avez des questions concernant la présente Charte ou une réclamation à propos des cookies et Outils de traçage, vous pouvez nous contacter :\n\n-En envoyant un e-mail à notre adresse email de contact : support@talesup.io\n-En envoyant un e-mail à notre référent à la protection des données : referent.donnees@talesup.io\n-En envoyant un courrier à l’adresse postale suivante :\nÀ l’attention du référent à la protection des données\nPériple Studio\n7 rue Viollet-le-Duc, Clermont-Ferrand\nFrance\n\nPour rappel, vous trouverez ci-dessous les informations concernant la société chargée d’appliquer cette Charte :\n\nSAS Périple Studio immatriculée sous le numéro 894 383 553 au RCS de Clermont-Ferrand, dont le siège social est situé au 7 rue Viollet-le-Duc, Clermont-Ferrand France et représentée par son président, Monsieur Victor Jaffeux.\n\nEnfin, n’oubliez pas de consulter notre Politique de confidentialité.",
        },
    ],
    whoWeAreTitle: "Qui sommes-nous ?",
    whoWeAre: [
        {
            type: "title",
            content: "À propos :",
        },
        {
            type: "text",
            content:
                "Nous sommes un studio français de développement de jeux vidéo et d’applications mobiles. Pour le moment, nous travaillons exclusivement sur Tales Up ! \n\nAujourd'hui, nous sommes une dizaine mais à la base, Tales Up était un projet étudiant beaucoup moins ambitieux. Notre foi en ce jeu nous a conduit à nous lancer à fond une fois nos études terminées. Depuis, on essaie d'en vivre :)",
        },
        { type: "image", content: "../../assets/images/team.jpg" },
        {
            type: "title",
            content: "Nos valeurs :",
        },
        {
            type: "text",
            content:
                "Nous souhaitons créer un jeu qui rende les jeux de rôles beaucoup plus accessibles. Notre but est de transformer le téléphone en outil pour rapprocher les gens et créer des liens, plutôt que de les isoler.\n\nNous créons des histoires qui nous parlent, dans l'espoir qu'elles parlent à d'autres ensuite, et nous avons vocation à créer des expériences de plus en plus uniques et de plus en plus immersives !\n\nNous souhaitons aussi créer quelque chose jouable par toutes et tous, avec un modèle économique qui ne repose ni sur la frustration ni sur des publicités intrusives.",
        },
        { type: "image", content: "../../assets/images/promo.jpg" },
        {
            type: "title",
            content: "Nos objectifs :",
        },
        {
            type: "text",
            content:
                "Nous espérons tout d'abord rentabiliser Tales Up et continuer à créer de nouvelles histoires, séries, sagas, tout en augmentant toujours le niveau de qualité global.\n\nNous espérons aussi créer de nouveaux jeux et de nouvelles applications innovantes, avec toujours dans l'idée de créer du lien entre les gens.",
        },
    ],
};
